import { FilterCategory } from "@/utils/constants";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PlaceFilterState {
  selectedCategory: FilterCategory | null;
  isDrawerOpen: boolean;
}

const initialState: PlaceFilterState = {
  selectedCategory: null,
  isDrawerOpen: false,
};

const placeFilterSlice = createSlice({
  name: "placeFilter",
  initialState,
  reducers: {
    setPlaceFilter: (state, action: PayloadAction<FilterCategory | null>) => {
      state.selectedCategory = action.payload;
      state.isDrawerOpen = true;
    },
    setDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isDrawerOpen = action.payload;
    },
    clearPlaceFilter: (state) => {
      state.selectedCategory = null;
      state.isDrawerOpen = false;
    },
  },
});

export const { setPlaceFilter, clearPlaceFilter, setDrawerOpen } =
  placeFilterSlice.actions;

export default placeFilterSlice.reducer;
